import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { AgGridReact } from '@ag-grid-community/react';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { useWellManagedCategoriesContext } from 'contexts/CategoryInsightsKpi/WellManagedCategoriesProvider';

const WellManagedCategoriesExplore = () => {
	const { gridData } = useWellManagedCategoriesContext();
	const { wellmanaged, vendorCountMin } = useContext(
		CategoryInsightsSettingsContext
	);

	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories where top ${vendorCountMin} vendors cover more than ${wellmanaged}% of category spend.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default WellManagedCategoriesExplore;
